/**
 * Photos for the Larovi-Ideenbuch (1.22, Mike 17.10.: "Du darfst selbst die passenden
 * aussuchen"): picked by hand on Unsplash – free Unsplash License only (no Unsplash+), no people,
 * no brands – stored small on our own hosting (`apps/web/public/ideenbuch/<id>.webp`, 640×480).
 * The licence asks for nothing, the credit is our courtesy: "Bildnachweis" in the app.
 */
export interface IdeaPhoto {
  /** the photographer as Unsplash names them */
  by: string;
  /** the photo's id on Unsplash – unsplash.com/photos/<id> */
  unsplash: string;
}

export const IDEA_PHOTOS: Record<string, IdeaPhoto> = {
  'baked-potatoes': { by: 'Monika Grabkowska', unsplash: 'N-xhCO5gY7s' },
  bolognese: { by: 'Homescreenify', unsplash: 'sA3wymYqyaI' },
  'broccoli-bake': { by: 'Lee Milo', unsplash: 'rShpgs9ThwI' },
  burgers: { by: 'Giorgi Iremadze', unsplash: '5ZR4DxAG3RQ' },
  'chicken-legs-potatoes': { by: 'Dr Muhammad Amer', unsplash: 'M0SGPmTIOrc' },
  'chicken-noodle-soup': { by: 'Bozhin Karaivanov', unsplash: 'n5JZzHqf8Ww' },
  'chicken-veg-pan': { by: 'montatip lilitsanong', unsplash: 'Tv7Bb8-341w' },
  'chicken-wraps': { by: 'Max Griss', unsplash: 'Spp1G283dow' },
  'chili-con-carne': { by: 'Artur Kornakov', unsplash: 'kwJhh14nUcs' },
  'chili-sin-carne': { by: 'Svitlana', unsplash: 'x4hFcY7N6Zg' },
  'courgette-fritters': { by: 'Max Griss', unsplash: 'qbjkVIixPCY' },
  'couscous-salad': { by: 'Sandie Clarke', unsplash: 'lGQvuvGlp0s' },
  'fish-fingers-mash': { by: 'Haseeb Modi', unsplash: '9fUCAqck4Zs' },
  'fish-lemon-rice': { by: 'Design Wala', unsplash: 'lDbGDnNe0CI' },
  flammkuchen: { by: 'Stefan Schauberger', unsplash: 'dIA0cK82cL8' },
  'french-toast': { by: 'Crystal Jo', unsplash: 'Q58N5cBKDZ8' },
  'fried-rice': { by: 'Pavan Reddy', unsplash: '-4V4SjHPPDk' },
  'gnocchi-spinach': { by: 'micheile henderson', unsplash: 'UzmWI5LwP70' },
  'goulash-noodles': { by: 'tommao wang', unsplash: 'VjQUnfHYj54' },
  kaesespaetzle: { by: 'Md Shohan Ridoy', unsplash: 'OYqXprumKqM' },
  kaiserschmarrn: { by: 'Babette Landmesser', unsplash: 'bf5BAUO3q2c' },
  'koenigsberger-klopse': { by: 'Dennis Birkebøg', unsplash: 'ZfzwlqywfDk' },
  lasagne: { by: 'Emanuel Ekström', unsplash: 'flEUTTwGlJQ' },
  'lentil-curry': { by: 'Paul', unsplash: '93L024xGEUM' },
  'maultaschen-broth': { by: 'Jonathan Kemper', unsplash: 'SFvVwwL6YWc' },
  'meatballs-potato-salad': { by: 'Egidijus Bielskis', unsplash: 'Wp2DicA5Gi0' },
  'meatballs-tomato': { by: 'Fidel Fernando', unsplash: '6eCpa9J3c_c' },
  'mustard-eggs': { by: 'Stephanie Sarlos', unsplash: 'yWZuWcJLwak' },
  pancakes: { by: 'Jaqueline Pelzer', unsplash: 'MytHEJlzdcM' },
  'pasta-salad': { by: 'engin akyurt', unsplash: 'X4QCAodTlh0' },
  'pea-risotto': { by: 'Julien Pianetti', unsplash: 'qIPRTMulc-g' },
  'pea-soup-sausages': { by: 'Margaret Jaszowska', unsplash: 'kR_rjgmItQk' },
  'peanut-bowl': { by: 'abdelkader1001', unsplash: 'OlHZpma28eU' },
  'potato-pancakes': { by: 'tommao wang', unsplash: 'Dut3u5zJ0vE' },
  'potato-soup': { by: 'Julia Kicova', unsplash: 'K-JgWmP_82k' },
  'pumpkin-soup': { by: 'Cala', unsplash: 'w6ftFbPCs9I' },
  quesadillas: { by: 'Lottie Griffiths', unsplash: 'pvTgyioFSTY' },
  'rice-pudding': { by: 'Rasmus Gundorff Sæderup', unsplash: 'p7n4g22Wqsg' },
  'roast-veg-feta': { by: 'Helgi Olgeirsson', unsplash: 'iM4pw-3hR74' },
  'salmon-cream-pasta': { by: 'Muhammad Fawdy', unsplash: 'WUPRF0S-oi4' },
  'salmon-tray': { by: 'Christine Siracusa', unsplash: '065eGbVSNOE' },
  schnitzel: { by: 'Mark König', unsplash: 'MyfbM2QYF4o' },
  'scrambled-eggs-bread': { by: 'amirali mirhashemian', unsplash: '4gmBIFraSuE' },
  shakshuka: { by: 'Yoav Aziz', unsplash: '422N7Nwq5XY' },
  'tomato-soup-toast': { by: 'sunorwind', unsplash: 'xBaa9lSMvP0' },
  'tomato-spaghetti': { by: 'Paish Zaini', unsplash: '-9UJTnXpUXM' },
  'tortellini-ham-cream': { by: 'Yoav Aziz', unsplash: 'kZYHddxKv9E' },
  'tray-chicken': { by: 'Peter Pham', unsplash: 'v5yVy3IhSRU' },
  'tray-pizza': { by: 'Chad Montano', unsplash: 'MqT0asuoIcU' },
  'veg-coconut-curry': { by: 'Daniela', unsplash: 'RELOvb0rrCE' },
};

/** Where the app finds an idea's photo. */
export const ideaPhotoUrl = (ideaId: string) =>
  IDEA_PHOTOS[ideaId] ? `/ideenbuch/${ideaId}.webp` : null;
